(function () {
  // Root cause of "thumbnail click does nothing": for a single-variant
  // product ("Default Title"), Dawn's product-info.js doesn't render the
  // [data-selected-variant] JSON block at all (there's no variant picker to
  // drive) — so this always returned null, the click handler's variant
  // guard always failed, and every click silently no-opped. Read our own
  // attribute (always rendered by the Liquid snippet, kept in sync on
  // variantChange below) first; only fall back to Dawn's node for products
  // that do have it.
  function selectedVariantId(root) {
    var attr = root.dataset.viziumCurrentVariantId;
    if (attr) return attr;
    var node = root.closest('product-info')?.querySelector('[data-selected-variant]');
    if (!node) return null;
    try { return JSON.parse(node.textContent).id; } catch (error) { return null; }
  }

  // Safe swap: never hide the currently-visible item until the newly
  // targeted one has actually finished loading (or failed — we still
  // commit on error rather than get stuck, since a broken asset is a
  // content problem, not a reason to leave the whole gallery blank).
  // Root cause this replaces: the old code toggled `hidden` on click
  // without ever moving `.is-active` onto the newly shown item, and
  // `.is-active` is what gives an item the slider's full-width layout
  // (see the CSS comment above `.vizium-wallet-gallery__item.is-active`).
  // An item that's unhidden but not `.is-active` keeps a slider-derived
  // sliver width from Dawn's list layout — visually an empty frame.
  function showItem(root, target, variantId) {
    if (!target) return false;
    var img = target.querySelector('img');

    function commit() {
      root.querySelectorAll('.vizium-wallet-gallery__item').forEach(function (item) {
        var isTarget = item === target;
        item.classList.toggle('is-active', isTarget);
        item.hidden = !isTarget;
      });
    }

    if (img && !img.complete) {
      if (img.loading === 'lazy') img.loading = 'eager'; // it's hidden, so native lazy-load's IntersectionObserver would never fire
      var settle = function () {
        img.removeEventListener('load', settle);
        img.removeEventListener('error', settle);
        commit();
      };
      img.addEventListener('load', settle);
      img.addEventListener('error', settle);
    } else {
      commit();
    }

    root.querySelectorAll('.vizium-wallet-gallery__thumb').forEach(function (thumb) {
      var sameVariant = thumb.dataset.viziumVariantId === variantId;
      thumb.hidden = !sameVariant;
      thumb.classList.toggle('is-active', sameVariant && thumb.dataset.viziumPosition === target.dataset.viziumPosition);
    });
    return true;
  }

  // Fallback chain per variant, in priority order, so the gallery is never
  // left empty even if a specific media/position lookup misses: the
  // requested item, then that variant's first (position 1) item, then any
  // item at all belonging to that variant.
  function resolveFallback(root, variantId) {
    var items = root.querySelectorAll('.vizium-wallet-gallery__item[data-vizium-variant-id="' + variantId + '"]');
    if (!items.length) return null;
    for (var i = 0; i < items.length; i++) {
      if (items[i].dataset.viziumPosition === '1') return items[i];
    }
    return items[0];
  }

  function syncGallery(root, variantId) {
    if (!root || !variantId) return;
    variantId = String(variantId);
    var target = resolveFallback(root, variantId);
    if (!target) return; // no media at all for this variant — leave prior state rather than blank it
    showItem(root, target, variantId);
  }

  function init(root) {
    syncGallery(root, selectedVariantId(root));
    root.addEventListener('click', function (event) {
      var thumb = event.target.closest('.vizium-wallet-gallery__thumb');
      if (!thumb) return;
      var variantId = thumb.dataset.viziumVariantId;
      if (variantId !== String(selectedVariantId(root))) return;
      var target = root.querySelector('[data-media-id="' + thumb.dataset.mediaId + '"]');
      if (!target) target = resolveFallback(root, variantId);
      showItem(root, target, variantId);
    });
    var productInfo = root.closest('product-info');
    // Dawn's product-info.js publishes variantChange only once its async
    // section fetch resolves (price/SKU/[data-selected-variant] refreshed by
    // then), so this is the reliable signal — the previous change+setTimeout(0)
    // listener fired before that fetch settled and read the stale variant id.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (productInfo && event.data.sectionId !== productInfo.dataset.section) return;
        var newVariantId = event.data.variant && event.data.variant.id;
        if (newVariantId) root.dataset.viziumCurrentVariantId = newVariantId;
        syncGallery(root, newVariantId);
      });
    } else {
      // Defensive fallback if pubsub isn't available for any reason.
      productInfo?.addEventListener('change', function (event) {
        if (!event.target.closest('variant-selects')) return;
        window.setTimeout(function () { syncGallery(root, selectedVariantId(root)); }, 300);
      });
    }
  }

  document.querySelectorAll('[data-vizium-wallet-gallery]').forEach(init);
})();
